export const MediaType = {
    IMAGE: "image",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_GIF: "image/gif",
    IMAGE_PNG: "image/png",
    IMAGE_TIFF: "image/tiff",
    IMAGE_ARW: "image/arw",
    IMAGE_WEBP: "image/webp",
    IMAGE_JPG: "image/jpg",
    IMAGE_SVG: "image/svg+xml",
    VIDEO: "video",
    AUDIO: "audio",
    VIDEO_MP4: "video/mp4",
    AUDIO_MP3: "audio/mp3",
    AUDIO_MPeg: "audio/mpeg",
}

export const MediaSubHeader = {
    IMAGE: "Image",
    VIDEO: "Video",
    AUDIO: "Audio",
    FILE: "File",
}

export const MediaFileType = {
    PDF: "pdf",
    ZIP: "zip",
    DOCX: "docx",
    DOC: "doc",
    XLSX: "xlsx",
    TXT: "txt",
    PPT: "ppt",
}

export enum FileTypes {
    XLSX_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    PDF_TYPE = "application/pdf",
    ZIP_TYPE = "application/x-zip-compressed",
    TEXT_TYPE = "text/plain",
    WORD_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
}

export const MessageType = {
    IMAGE: "image",
    VIDEO: "video",
    AUDIO: "audio",
    FILE: "file",
    TEXT: "text",
    Template: "template"
}